import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import shallow from 'zustand/shallow';
import { InventoryStatsData } from '../../@types/inventory';
import { UnitSoldIcon } from '../../assets/icons/UnitSoldIcon';
import { WidgetIcon } from '../../assets/icons/widgetIcon';
import { InfoCard, InfoCardProps } from '../../components/core/InfoCard';
import InventoryTable from '../../components/inventory/Table';
import { useInventorySearch } from '../../hooks';
import { useInventoryStore } from '../../state/useInventoryStore';
import InventoryListTable from '../../components/inventory/list/InventoryListTable';
import Naira from '../../assets/icons/Naira';
import { SidebarDrawer } from '../../components/common';
import InventoryDeletePrompt from '../../components/inventory/InventoryDeletePrompt';
import { getInventoryStats } from '../../backend-services';
import { toast } from 'react-hot-toast';

const ListInventoryPage = () => {
  const location = useLocation();
  const [params] = useSearchParams();
  const [showPrompt, setShowPrompt] = React.useState(false);
  const [inventoryId, setInventoryId] = React.useState('');

  const [data, setData] = React.useState<InventoryStatsData>({
    totalInventory: 0,
    totalValue: 0,
    totalUnitsSold: 0,
  });

  const { fetchInventory, fetchMoreData, onSearchData, handleFilter, fetchData, handleSort, removeInventory } =
    useInventoryStore(
      (state) => ({
        fetchInventory: state.fetchInventory,
        fetchMoreData: state.fetchMoreData,
        onSearchData: state.setSearchText,
        handleFilter: state.setFilter,
        fetchData: state.fetchData,
        handleSort: state.handleSort,
        setFilter: state.setFilter,
        removeInventory: state.removeInventory,
      }),
      shallow,
    );

  const { inventory, isLoading, range, pagination, searchText, filter } = useInventoryStore(
    (state) => ({
      inventory: state.inventory,
      isLoading: state.isLoading,
      filter: state.filter,
      searchText: state.searchText,
      range: state.range,
      pagination: state.pagination,
      error: state.error,
    }),
    shallow,
  );

  const fetchInventoryStats = async () => {
    try {
      const res = await getInventoryStats();
      setData({
        totalInventory: res.totalInventorues,
        totalValue: res.totalAmount,
        totalUnitsSold: res.QuantitySold,
      });
    } catch (error) {
      toast.error('Failed to load inventory stats');
    }
  };

  useEffect(() => {
    fetchInventoryStats();
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [searchText, filter, range, fetchData]);

  useEffect(() => {
    fetchInventory();
  }, [params, location.state, fetchInventory]);

  const handleDeleteInventory = (id: string) => {
    setShowPrompt(true);
    setInventoryId(id);
  };

  const { data: searchResult, isSearching, handleSearch: handleInventorySearch } = useInventorySearch();
  const infoCardData = [
    {
      title: 'Total Values',
      value: `${data.totalValue}`,
      color: 'active',
      icon: <Naira />,
      isLoading: isLoading,
    },
    {
      title: 'Total Inventory',
      value: `${data.totalInventory}`,
      color: 'secondary',
      icon: <WidgetIcon />,
      isLoading: isLoading,
    },
    {
      title: 'Total Units Sold',
      value: `${data.totalUnitsSold}`,
      color: 'primary',
      icon: <UnitSoldIcon />,
      isLoading: isLoading,
    },
  ] as InfoCardProps[];

  console.log(searchResult)
  return (
    <>
      <div className="mb-[32px]">
        {showPrompt && (
          <div>
            <SidebarDrawer
              title={'Delete Inventory'}
              show={true}
              position={'left'}
              onClose={() => setShowPrompt(false)}
            >
              <InventoryDeletePrompt
                setShowPrompt={setShowPrompt}
                inventoryId={inventoryId}
                fetchInventory={fetchInventory}
              />
            </SidebarDrawer>
          </div>
        )}
        <div className="flex justify-between items-center">
          <h1 className="font-medium text-[18px] xl:text-[20px] lg:ml-[0em] md:ml-[0em] ">Inventory Management</h1>
        </div>
        <div className="hidden md:block mt-4">
          <div className="grid grid-cols-3 gap-6 lg:gap-[20px] xl:ml-[0.3em] lg:ml-[0.3em]">
            {infoCardData.map((cardData, i) => (
              <div key={i}>
                <InfoCard {...cardData} />
              </div>
            ))}
            {infoCardData.length < 3 &&
              Array.from({ length: 3 - infoCardData.length }).map((_, index) => <div key={index}></div>)}
          </div>
        </div>
        <div className="md:hidden space-y-4">
          <div className="grid">
            {infoCardData.slice(0, 1).map((cardData, i) => (
              <InfoCard {...cardData} />
            ))}
          </div>
          <div className="grid grid-cols-2 gap-4">
            {infoCardData.slice(1, 3).map((cardData, i) => (
              <InfoCard {...cardData} />
            ))}
          </div>
        </div>
      </div>

      <div className="hidden md:block">
        <InventoryListTable
          fetchMoreData={fetchMoreData}
          onSearchData={onSearchData}
          handleSort={handleSort}
          handleFilter={handleFilter}
          handleSearch={handleInventorySearch}
          meta={pagination}
          inventory={inventory}
          isLoading={isLoading}
          isSearching={isSearching}
          searchResult={searchResult}
          selectedFilter={filter}
          handleDeleteInventory={handleDeleteInventory}
        />
      </div>
      <div className="justify-center items-center mt-8 md:hidden">
        <InventoryListTable
          fetchMoreData={fetchMoreData}
          onSearchData={onSearchData}
          handleSort={handleSort}
          handleFilter={handleFilter}
          handleSearch={handleInventorySearch}
          meta={pagination}
          inventory={inventory}
          isLoading={isLoading}
          isSearching={isSearching}
          searchResult={searchResult}
          selectedFilter={filter}
          handleDeleteInventory={handleDeleteInventory}
        />
        {/* <InventoryTable
          fetchMoreData={fetchMoreData}
          onSearchData={onSearchData}
          handleSort={handleSort}
          // handleFilter={handleFilter}
          handleSearch={handleInventorySearch}
          meta={pagination}
          inventory={inventory}
          isLoading={isLoading}
          isSearching={isSearching}
          searchResult={searchResult}
          selectedFilter={filter}
          handleDeleteInventory={handleDeleteInventory}

        /> */}
      </div>
    </>
  );
};

export { ListInventoryPage };
